export default {
  translation: {
    tabs: {
      closeButton: 'Close tab',
      addButton: {
        text: '+',
        tooltip: 'New Tab',
      },
    },
    search: {
      placeholder: 'Enter a search query or enter a URL',
      label: 'Search field',
    },
  },
};
